import { useLayoutEffect, useRef } from 'react';
import { gsap, revealUp } from '../lib/motion';
import AutoVideo from '../lib/AutoVideo';

export default function Story() {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctx = gsap.context(() => {
      revealUp('.story-reveal', el);
    }, el);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={ref} id="story" className="relative bg-ink-950 py-28 md:py-44">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-10 lg:grid-cols-12 lg:gap-20">
        {/* Living founder portrait */}
        <div className="story-reveal relative lg:col-span-5">
          <div className="relative mx-auto max-w-md overflow-hidden">
            <AutoVideo
              src="/videos/ceo-portrait.mp4"
              poster="/images/ceo.jpg"
              className="aspect-[3/4] w-full"
            />
          </div>
          <div className="pointer-events-none absolute -inset-3 mx-auto max-w-md border border-gold-500/25" />
          <p className="mt-8 text-center text-[11px] uppercase tracking-widest2 text-steel-400">
            Founder · Revive Builders
          </p>
        </div>

        <div className="lg:col-span-7">
          <p className="story-reveal eyebrow mb-8">The Story</p>
          <h2 className="story-reveal font-display text-5xl font-medium leading-[1.04] text-steel-100 md:text-7xl">
            Built on
            <br />
            <span className="italic text-gold-300">integrity.</span>
          </h2>
          <div className="story-reveal mt-10 h-px w-20 bg-gold-500/50" />
          <p className="story-reveal mt-10 max-w-xl text-lg font-light leading-relaxed text-steel-300 md:text-xl">
            Founded in 2021 on twenty years in the trade, Revive Builders is a general
            contractor for owners who measure work in decades — not punch lists.
          </p>
          <p className="story-reveal mt-6 max-w-xl text-base font-light leading-relaxed text-steel-400">
            Three hundred units a year. Twelve service lines — construction through grounds
            care — across Central Texas — every one delivered with the same quiet
            standard: do it right, or do it again.
          </p>
          <div className="story-reveal mt-12 grid max-w-xl grid-cols-2 gap-8 border-t border-steel-100/10 pt-10 sm:grid-cols-4">
            {['Integrity', 'Safety', 'Client-First', 'Excellence'].map((v) => (
              <p key={v} className="text-xs uppercase tracking-[0.2em] text-gold-400/90">{v}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
